"use strict";
/**
 * @module Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defined reason code and message used to report error conditions.
 */
var ErrorReason = /** @class */ (function () {
    /**
     * Create an error reason
     *
     * @param  id       the error reason's id
     * @param  reason   the error reason's description
     */
    function ErrorReason(id, reason) {
        this.id = id;
        this.reason = reason;
    }
    /**
     * Convert the error reson to a string
     *
     * @return a string representation of the error reason
     */
    ErrorReason.prototype.toString = function () {
        return this.id + ': ' + this.reason;
    };
    return ErrorReason;
}());
exports.ErrorReason = ErrorReason;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/error-reason.js
// module id = 393
// module chunks = 0